/* eslint-disable import/prefer-default-export */
export const noBackgroundImage = (image) => {
  if (image) {
    return {
      'background-image': `url(${image})`,
    };
  } return {
    'background-image': 'url(\'https://static.car.gr/static/images/no_photo.png\')',
  };
};
